import React from "react";
import { money } from "@/lib/financeApi";
import { typeLabel } from "@/lib/partnerApi";

const H = ({ children }) => <h4 className="font-mono text-[10px] tracking-[0.2em] uppercase text-nex-muted">{children}</h4>;
const Stat = ({ label, value, testid }) => (
  <div data-testid={testid} className="border border-white/10 rounded-sm p-3"><div className="font-mono text-[9px] tracking-[0.2em] uppercase text-nex-muted">{label}</div><div className="text-xl text-nex-silver font-semibold mt-1">{value}</div></div>
);

/** Aggregate-only stats — shared by the admin card and the partner portal. No individual resident data. */
export default function ProgramStatsView({ s, testid = "par-stats" }) {
  const phases = Object.entries(s.residents.by_phase).sort();
  return (
    <div data-testid={testid} className="space-y-6">
      <section className="space-y-2"><H>Residents by phase · {s.residents.total} active</H>
        <div className="grid grid-cols-2 sm:grid-cols-4 gap-2">{phases.length ? phases.map(([p, n]) => <Stat key={p} testid={`${testid}-phase-${p}`} label={`Phase ${p}`} value={n} />) : <span className="text-sm text-nex-muted">No active residents.</span>}</div>
      </section>
      <section className="space-y-2"><H>Pillar completion · average across active residents</H>
        {s.pillars.map((p) => (
          <div key={p.pillar_id} data-testid={`${testid}-pillar-${p.pillar_id}`} className="space-y-1">
            <div className="flex text-sm"><span className="text-nex-silver">{p.name}</span><span className="ml-auto font-mono text-xs text-nex-gold">{p.completion_pct}%</span></div>
            <div className="h-1.5 bg-white/5 rounded-full overflow-hidden"><div className="h-full bg-nex-gold transition-[width] duration-700" style={{ width: `${Math.min(p.completion_pct, 100)}%` }} /></div>
          </div>
        ))}
      </section>
      <section className="grid sm:grid-cols-2 gap-6">
        <div className="space-y-2"><H>Donations &amp; sponsorships</H>
          <div className="grid grid-cols-2 gap-2">
            <Stat testid={`${testid}-donations`} label="Donations received" value={money(s.donations.total)} />
            <Stat testid={`${testid}-monthly`} label="Monthly sponsorship" value={`${money(s.sponsorships.monthly_committed)}/mo`} />
            <Stat label="One-time sponsorships" value={money(s.sponsorships.one_time_total)} />
            <Stat label="Active sponsorships" value={`${s.sponsorships.active} · ${s.sponsorships.in_kind} in-kind`} />
          </div>
        </div>
        <div className="space-y-2"><H>Partners &amp; referrals</H>
          <div className="grid grid-cols-2 gap-2">
            {Object.entries(s.partners.by_type).map(([t, n]) => <Stat key={t} testid={`${testid}-partners-${t}`} label={typeLabel(t)} value={n} />)}
            <Stat testid={`${testid}-referrals`} label="Referrals submitted" value={s.referrals.total} />
            <Stat testid={`${testid}-acceptance`} label="Acceptance rate" value={s.referrals.acceptance_rate == null ? "—" : `${s.referrals.acceptance_rate}%`} />
          </div>
        </div>
      </section>
    </div>
  );
}
